import { gql } from '@apollo/client'

const UPDATE_LOCATION_TYPE_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateLocationTypeSimpleDetails(
    $id: ID!
    $data: LocationTypeDetailsInput!
  ) {
    updateLocationTypeSimpleDetails(id: $id, data: $data) {
      id
      position
      description
      synonyms
      isExcludedFromSearch
      isExcludedFromBrowsing
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export default UPDATE_LOCATION_TYPE_SIMPLE_DETAILS_MUTATION
